import makeCrud from '@/store/site/localization/crud'

// Pazarlama toplu gönderim kampanyaları (e-posta / SMS / push) + hedef kitle.
const base = makeCrud('ecommerce_marketing_campaign')

export default {
    ...base,
    actions: {
        ...base.actions,

        // Kural tipleri / kanallar.
        async meta() {
            const res = await this._vm.axios.get(this._vm.endpoint.get('ecommerce_marketing_campaign_meta'))
            return res.data.data
        },

        // Hedef kitle büyüklüğü önizleme.
        async previewAudience(_, {channel, audience}) {
            const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_marketing_campaign_preview'), {channel, audience})
            return res.data?.data?.count ?? 0
        },

        // Kampanyayı gönder (arka plan).
        async sendCampaign(_, {id}) {
            const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_marketing_campaign') + '/' + id + '/send')
            return res.data
        },
    },
}
